import styled, { css } from 'styled-components'
import { PopupButton } from '@typeform/embed-react'
import variables, { colors, device } from 'Styled/variables'

export const GotItContainer = styled.div`
  margin: 0 auto;
`
export const SidebarContentWrapper = styled.div`
  z-index: 1000;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 30px);
  @media ${device.mobileMin} {
    overflow: hidden;
    height: calc(100vh - 60px);
  }
`

export const HintValidationPortal = styled.div`
  position: absolute;
  z-index: 1001;
  right: 0;
  top: 6%;
  border-radius: 4px;
  transform: translate(102%);
  padding: 26px 24px;
  color: ${colors.mainText};
  background: ${colors.white};
  font-size: ${variables.fontSize14};
  font-family: sans-serif;
  line-height: 1;
  z-index: 100;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 320px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const SidebarAvatar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 222px;
  padding-top: 40px;
`

export const SidebarImg = styled.img`
  border-radius: 50%;
  margin-bottom: 16px;
  min-height: 120px;
  width: 120px;
  object-fit: cover;
`

export const SidebarTitleName = styled.div`
  margin-bottom: 4px;
  font-size: ${variables.fontSize14};
  font-weight: 600;
  line-height: 21px;
  color: ${colors.mainText};
  text-transform: capitalize;
`

export const SidebarTitleRole = styled.div`
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 4px;
  color: ${colors.mainText};
  text-transform: capitalize;
`

export const ValidationBlock = styled.div`
  display: flex;
  align-items: center;
  z-index: 1000;
  position: relative;
`

export const ValidationText = styled.div`
  color: ${colors.messegesYellow1};
  margin-right: 8px;
`

export const ValidationInfoHint = styled.div`
  color: ${colors.messegesYellow1};
  margin-right: 8px;
`

export const SidebarLinkItem = styled.li`
  color: ${colors.mainText};
  height: 40px;
  transition: all 0.3s;
  cursor: pointer;
  align-items: center;
  background: transparent;
  border: none;
  display: flex;

  ${({ collapse }: { collapse: boolean }) =>
    collapse
      ? css`
          flex-direction: column;
          justify-content: center;
        `
      : css`
          width: 240px;
          padding: 12px 16px;
        `};
`

export const StyledPopupButton = styled(PopupButton)`
  background-color: transparent;
  padding: 0;

  ${({ collapse }: { collapse: boolean }) =>
    collapse
      ? ``
      : css`
          display: flex;
        `};
`

export const SidebarLinkText = styled.div`
  position: relative;
  color: ${colors.mainText};
  margin: 0;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  display: flex;
  left: 10px;
  width: 160px;
`

export const SidebarIconBlock = styled.div`
  margin-right: 6px;
`

export const AnaliticsUsersBlock = styled.div`
  padding-left: 24px;
`

export const ArtistSideBar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
`
export const Top = styled.div``
export const Bottom = styled.div``
export const BottomInner = styled.div`
  border-top: 1px solid ${colors.greyStroke};
`

export const Logout = styled.div`
  border-top: 1px solid ${colors.greyStroke};
  @media ${device.mobileMin} {
    margin-bottom: 0px;
  }
`

export const DeactivatedLabel = styled.span`
  font-size: 14px;
  color: ${colors.messegesRed};
`
